import {IViewCamera, IViewItemConfig} from "../components/screens/vscSiteSpecific/SiteSpecific";


export interface IOn2ServerConfig {
    serverUri: string;
}
export interface ISlsOrdOpt {
    selectionID:string;
    selectionName: string;
    valueID: string;
    valueName:string;
    style:string;
}

export interface IModel {
    id:string;
    objectRid: number;
    marketingName: string;
    bedrooms: string;
    baths: string;
    marketingPrice:number;
    sqf: string;
    images: IImages;
}
export interface IImages {
    elevation: string;
    firstFloor: string;
    secondFloor:string;
    thirdFloor:string;
    parking?: string;
}
export interface ISlsOrd {
    lotId: string;
    id: string;
    blockNumber: string;
    images: IImages;
    lotNumber: string;
    lotStreetAddress:string;
    modelId: string;
    isSold: boolean;
    reservedTo:number;
    waitlist: number[];
    marketingName: string;
    bedrooms: string;
    baths: string;
    price:number;
    style: string;
    sqf: string;
    modelRid: number;
    options: ISlsOrdOpt[];
}
export interface ICamera {
    name: string;
    description?:string;
    /**
     * The unreal Id
     */
    id:string;
}
export interface ISlsOrdResponse {
    homes: ISlsOrd[];
    cameras: ICamera[];
    views?: IViewItemConfig[];
    features?: string[];
}
export interface ISlsOrdClient {
    getSlsOrds(customerId?: number): Promise<ISlsOrd[]>;
    getCommunityInfo(customerId?:number): Promise<ISlsOrdResponse>;

}
class SlsOrdClient implements ISlsOrdClient {

    private readonly serverUri:string;

    constructor(private config:IOn2ServerConfig) {
        this.serverUri = config.serverUri;
    }

    async getCommunityInfo(customerId?:number) {
        let uri = `${this.serverUri}homes`;
        if (customerId !== undefined) uri += `?customerId=${customerId}`;
        const res = await fetch(uri);
        const jsonResult = await res.json() as ISlsOrdResponse;
        // Make the ImageUris absolute

        /*for (const slsOrd of jsonResult.homes) {
            for (const imageKey of Object.keys(slsOrd.images)) {
                const imageKeyTyped = imageKey as keyof ISlsOrd["images"]
                slsOrd.images[imageKeyTyped] = this.serverUri + slsOrd.images[imageKeyTyped];
            }

        }*/
        return jsonResult;
    }
    async getSlsOrds(customerId?:number) {
        const rval = await this.getCommunityInfo(customerId);
        return rval.homes ?? [];
    }
}


export default SlsOrdClient;